var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6669 9.7C26.5279 8.39921 25.9001 6.729 25.9003 5H20.7503V25.6667C20.7114 26.7853 20.2395 27.8451 19.4341 28.6225C18.6288 29.3999 17.5529 29.834 16.4336 29.8333C14.0669 29.8333 12.1003 27.9 12.1003 25.5C12.1003 22.6333 14.8669 20.4833 17.7169 21.3667V16.1C11.9669 15.3333 6.93359 19.8 6.93359 25.5C6.93359 31.05 11.5336 35 16.4169 35C21.6503 35 25.9003 30.75 25.9003 25.5V15.0167C27.9886 16.5164 30.4959 17.3211 33.0669 17.3167V12.1667C33.0669 12.1667 29.9336 12.3167 27.6669 9.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokWhite);
export default __webpack_public_path__ + "static/media/tiktok-white.8107558a4a3fdd29387f00b2b3cb12cb.svg";
export { ForwardRef as ReactComponent };